/* TGFM PDP v3: pilot fail-closed e acquisto atomico nel solo template pubblico. */
(function () {
  'use strict';

  function moneyFormatter(currency) {
    if (typeof Intl === 'undefined' || typeof Intl.NumberFormat !== 'function') {
      return null;
    }

    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: currency || 'EUR'
      });
    } catch (error) {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR'
      });
    }
  }

  function formatCents(cents, formatter, currency) {
    var amount = (Number(cents) || 0) / 100;
    if (formatter) return formatter.format(amount);
    return amount.toFixed(2).replace('.', ',') + ' ' + (currency || 'EUR');
  }

  function createConfigurationId() {
    var cryptoApi = window.crypto;
    if (!cryptoApi) return '';
    if (typeof cryptoApi.randomUUID === 'function') return cryptoApi.randomUUID();
    if (typeof cryptoApi.getRandomValues !== 'function') return '';

    var bytes = new Uint8Array(16);
    cryptoApi.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.prototype.map.call(bytes, function (byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
    return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
  }

  function errorMessage(error) {
    var status = error && error.status;
    if (status === 422) return 'Il PC o una delle opzioni non è più disponibile nella quantità richiesta.';
    return 'Non abbiamo ricevuto conferma dell’aggiunta.';
  }

  function initProduct(root) {
    if (!root || root.getAttribute('data-tgfm-v3-ready') === 'true') return;
    root.setAttribute('data-tgfm-v3-ready', 'true');

    var basePrice = parseInt(root.getAttribute('data-tgfm-v3-base-price-cents'), 10) || 0;
    var currency = root.getAttribute('data-tgfm-v3-currency') || 'EUR';
    var formatter = moneyFormatter(currency);
    var purchaseState = root.getAttribute('data-tgfm-v3-purchase-state') || 'draft_disabled';
    var parentVariantId = root.getAttribute('data-tgfm-v3-parent-variant-id') || '';
    var cartAddUrl = root.getAttribute('data-tgfm-v3-cart-add-url') || '';
    var cartUrl = root.getAttribute('data-tgfm-v3-cart-url') || '';
    var radios = root.querySelectorAll('[data-tgfm-v3-delta-cents]');
    var totalNodes = root.querySelectorAll('[data-tgfm-v3-total], [data-tgfm-v3-sticky-total]');
    var statusNode = root.querySelector('[data-tgfm-v3-config-status]');
    var disabledCtas = root.querySelectorAll('[data-tgfm-v3-disabled-cta]');
    var configJumps = root.querySelectorAll('[data-tgfm-v3-config-jump]');
    var finalAdd = root.querySelector('[data-tgfm-v3-final-add]');
    // Pulsante "Aggiungi al carrello" sotto il prezzo: stessa aggiunta del
    // riepilogo finale, con la configurazione scelta (di base se nessuna).
    var quickAdd = root.querySelector('[data-tgfm-v3-quick-add]');
    var contactCta = root.querySelector('[data-tgfm-v3-contact-cta]');
    var errorNode = root.querySelector('[data-tgfm-v3-error]');
    var helpNode = root.querySelector('[data-tgfm-v3-cta-help]');
    var defaultHelp = helpNode ? helpNode.textContent.trim() : '';
    var pending = false;
    var uncertain = false;

    Array.prototype.forEach.call(disabledCtas, function (button) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });

    Array.prototype.forEach.call(configJumps, function (link) {
      link.addEventListener('click', function (event) {
        var targetId = (link.getAttribute('href') || '').replace(/^#/, '');
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;

        event.preventDefault();
        var reduceMotion = window.matchMedia
          && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        try {
          target.focus({ preventScroll: true });
        } catch (error) {
          target.focus();
        }

        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    function updateTotal() {
      var delta = 0;
      var selectedUpgrades = 0;
      var noteOnlySelected = false;

      Array.prototype.forEach.call(radios, function (radio) {
        if (!radio.checked || radio.disabled) return;
        if (radio.getAttribute('data-tgfm-v3-note-only') === 'true') {
          noteOnlySelected = true;
          return;
        }
        var radioDelta = parseInt(radio.getAttribute('data-tgfm-v3-delta-cents'), 10) || 0;
        delta += radioDelta;
        if (radio.getAttribute('data-tgfm-v3-child-id')) selectedUpgrades += 1;
      });

      var formatted = formatCents(basePrice + delta, formatter, currency);
      Array.prototype.forEach.call(totalNodes, function (node) {
        node.textContent = formatted;
      });

      if (statusNode) {
        statusNode.textContent = noteOnlySelected
          ? 'Richiede conferma TGFM'
          : (selectedUpgrades === 0
            ? 'Configurazione di base'
            : selectedUpgrades + (selectedUpgrades === 1 ? ' personalizzazione' : ' personalizzazioni'));
      }

      if (finalAdd) finalAdd.hidden = noteOnlySelected;
      if (contactCta) contactCta.hidden = !noteOnlySelected && purchaseState !== 'blocked';
      if (helpNode) {
        helpNode.textContent = noteOnlySelected
          ? 'Verifichiamo insieme prezzo e disponibilità di questa opzione su WhatsApp.'
          : defaultHelp;
      }

      return noteOnlySelected;
    }

    function setError(message) {
      if (!errorNode) return;
      errorNode.textContent = message || '';
      errorNode.hidden = !message;
      if (message) {
        errorNode.setAttribute('tabindex', '-1');
        errorNode.focus();
      }
    }

    function selectedChildIds() {
      var ids = [];
      Array.prototype.forEach.call(radios, function (radio) {
        if (!radio.checked || radio.disabled) return;
        var childId = radio.getAttribute('data-tgfm-v3-child-id');
        if (childId) ids.push(childId);
      });
      return ids;
    }

    function addConfiguration(event) {
      var trigger = (event && event.currentTarget) || finalAdd;
      if (!finalAdd || !trigger || purchaseState !== 'enabled' || pending || uncertain) return;
      if (updateTotal()) {
        if (contactCta) {
          contactCta.focus();
          contactCta.scrollIntoView({ block: 'center' });
        }
        return;
      }
      if (!parentVariantId || !cartAddUrl || !cartUrl) {
        setError('Dati carrello incompleti. Aggiorna la pagina e riprova.');
        return;
      }

      var configurationId = createConfigurationId();
      if (!configurationId) {
        setError('Il browser non può creare un identificativo sicuro per la configurazione.');
        return;
      }

      var properties = { _tgfm_configuration_id: configurationId };
      var items = [{ id: parentVariantId, quantity: 1, properties: properties }];
      Array.prototype.forEach.call(selectedChildIds(), function (childId) {
        items.push({
          id: childId,
          quantity: 1,
          parent_id: parentVariantId,
          properties: { _tgfm_configuration_id: configurationId }
        });
      });

      var idleLabel = trigger.textContent;
      setError('');
      pending = true;
      Array.prototype.forEach.call([finalAdd, quickAdd], function (button) {
        if (button) button.disabled = true;
      });
      trigger.setAttribute('aria-busy', 'true');
      trigger.textContent = 'Aggiunta in corso…';
      Array.prototype.forEach.call(root.querySelectorAll('fieldset'), function (fieldset) {
        fieldset.disabled = true;
      });
      var controller = new AbortController();
      var requestTimeout = window.setTimeout(function () { controller.abort(); }, 15000);

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        signal: controller.signal,
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw { status: response.status, body: body };
          if (!body.items || body.items.length !== items.length) throw { status: 0 };
          return body;
        });
      }).then(function () {
        window.clearTimeout(requestTimeout);
        window.location.assign(cartUrl);
      }).catch(function (error) {
        window.clearTimeout(requestTimeout);
        // La risposta puo' perdersi dopo la scrittura. Nessun secondo POST
        // automatico o nuovo tentativo finche' il cliente non vede il carrello.
        pending = false;
        uncertain = true;
        setError(errorMessage(error) + ' Controlla il carrello prima di riprovare.');
        if (errorNode) {
          var link = document.createElement('a');
          link.href = cartUrl;
          link.textContent = ' Apri il carrello';
          errorNode.appendChild(link);
        }
        trigger.removeAttribute('aria-busy');
        trigger.textContent = idleLabel;
      });
    }

    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', updateTotal);
    });

    if (finalAdd) finalAdd.addEventListener('click', addConfiguration);
    if (quickAdd) quickAdd.addEventListener('click', addConfiguration);

    updateTotal();
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = context.querySelectorAll('[data-tgfm-pdp-v3]');
    Array.prototype.forEach.call(roots, initProduct);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
